<template>
    <div class="employee-skills-single">
        <div class="placeholder">
            <div class="placeholder__heading">
                {{ data.full_name }}
            </div>
            <div class="placeholder">

                <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                    v-if="!loading"
                    @on-row-click="selectProjectType"
                    :row-style-class="selectedRowClass"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            {{ props.row.coverage_percent | coveragePercent }} 
                            <div
                                v-if="props.row.coverage_percent !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                            />
                        </div>
                        <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name ? props.row.name : '-'">
                            {{ props.row.name ? props.row.name : '-' }}
                        </div>
                        <div v-else-if="props.column.field == 'coverage'">
                            {{ props.row.coverage | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'invoices_total'">
                            {{ props.row.invoices_total | currency }}
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                            {{ props.row.coverage_per_hour | currency }} 
                            <div
                                v-if="props.row.coverage_per_hour !== null"
                                class="coverage-indicator"
                                :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                            />
                        </div>
                        <div v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

                <box-loading height="350" v-else />

            </div>
        </div>

        <br>

        <employee-skills-single-projects :data="selectedRow" v-if="selectedRow" />

        <div v-else>
            Vælg en opgavetype for at se de enkelte opgaver her
        </div>

    </div>
</template>

<script>
import * as employeeService from '@/services/employeeService'

export default {
    props: ['data'],
    data () {
        return {
            loading: true,
            selectedRow: null,
            rows: [],
            columns: [
                { label: 'Opgavetype', field: 'name', type: 'string' },
                { label: 'Antal i perioden', field: 'projects_count', type: 'number' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.selectedRow = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            employeeService.skills(this.data.uuid, params, (response) => {
                this.rows = response.data ? response.data.project_types : []
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectProjectType (projectType) {
            this.selectedRow = projectType.row
            console.log(projectType)
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected'
            }
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        data: function () {
            this.getData()
        },
        globalParams: function () {
            this.getData()
        }
    },
    components: {
        'employee-skills-single-projects': require('./components/employeeSkillsSingleProjects')
    }
}
</script>



// WEBPACK FOOTER //
// employeeSkillsSingle.vue?c7cdaf10